import "../modules/stacked-bar-chart";

$.onmount("[data-behavior~=stacked-bar-chart]", function() {
  $(this).renderStackedBarChart();
});
